import React from "react";

function DefaultWidget() {
  return <div></div>;
}

export default DefaultWidget;
